/**
 * Meteo — Página independiente de consulta meteorológica.
 * Accesible desde el menú lateral para todos los usuarios con sesión.
 * Cuando se accede dentro de un expediente, se usa `MeteoTab` con el
 * expedienteId precargado para que el PDF se adjunte automáticamente.
 */
import MeteoPanel from "@/components/meteo/MeteoPanel";
import { CloudLightning } from "@phosphor-icons/react";

export default function Meteo() {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 md:py-6 space-y-5"
         data-testid="meteo-page">
      <header className="flex items-center gap-3">
        <span className="icon-chip icon-chip-brand">
          <CloudLightning className="w-4 h-4" weight="regular" />
        </span>
        <div className="flex-1">
          <h1 className="page-title">Consulta meteorológica</h1>
          <p className="help-text">
            Histórico y previsión por dirección + fecha. Fuentes oficiales:
            AEMET (España) y Open-Meteo (ERA5). Visor de rayos complementario:
            mapaderayos.com.
          </p>
        </div>
      </header>
      <MeteoPanel />
    </div>
  );
}
